import script from "./ControlViewTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlViewTab.vue?vue&type=script&setup=true&lang=ts"

import "./ControlViewTab.vue?vue&type=style&index=0&id=1d19b5fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d19b5fb"]])

export default __exports__